import React from 'react';
import { matchMethodMeta } from '../../constants/relationships';

/**
 * G5E — badge de explicabilidade do match_method retornado pela RPC
 * resolve_email_relationship_context (rótulos PT em constants/relationships).
 */
export default function MatchMethodBadge({ method, className = '' }) {
  const meta = matchMethodMeta(method);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium ${meta.color} ${className}`}
      title={method || ''}
    >
      {meta.label}
    </span>
  );
}
